module.exports = __webpack_public_path__ + "img/智能识别--毛发识别.9f85c19e.png";